export default "__VITE_ASSET__BkMxC8n0__"